import { useCookies } from 'react-cookie';

import { CompanyMembershipActionType } from '@type-def_iqfu/CompanyType';

type Props = {
  companyId: string;
};

export const useCompanyMembershipAction = ({ companyId }: Props) => {
  const [cookies] = useCookies(['expiry', 'access-token', 'client', 'uid', 'user-type']);

  const postCompanyMembershipStatusChangeAction = async (action: CompanyMembershipActionType) => {
    const url = `${process.env.NEXT_PUBLIC_DEV_BACKEND_URL}/admin/companies/${companyId}/${action}`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          uid: cookies.uid,
          client: cookies.client,
          'access-token': cookies['access-token'],
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      return result;
    } catch (error) {
      console.error(error);
      return { success: false };
    }
  };

  return {
    postCompanyMembershipStatusChangeAction,
  };
};
